<template>
  <Modal v-model="showModal" footer-hide class="text-center" width="350px">
    <img src="~@/assets/images/logo/Kromnix-logo-vertical_light_bg.png" alt="kromnix logo" width="50px">
    <p class="padding-b-20">Tech Providers Shortlist : <b>{{ getRfpShortList.length }}</b></p>
    <Card style="margin-bottom:20px;" class="clickable" @click.native="handleFreeTrial" v-if="isFreeTrial">
      <h3>Free trial for 3 months</h3>
      <p>Send MyRFP to {{ getRfpShortList.length }} Tech Providers</p>
    </Card>
    <Card style="background:#7F7F7F;color:#fff;" class="clickable" @click.native="handlePayment">
      <h3>Pay as you need</h3>
      <p>€100 per MyRFP submission (activated after free trial)</p>
    </Card>
  </Modal>
</template>

<script>
import { rfpFreeTrial } from '@/services/rfps'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      showModal: false,
      isFreeTrial: false
    }
  },

  computed: {
    ...mapGetters(
      {
        getRfpShortList: 'rfps/getRfpShortList'
      }
    )
  },

  methods: {
    openModal (shortListCount) {
      this.showModal = true
      this.getFreeTrialAccess()
    },

    handlePayment () {
      this.showModal = false
      this.$router.push({
        name: 'payment-summary'
      })
    },

    handleFreeTrial () {
      this.showModal = false
      this.$router.push({
        name: 'rfp-form'
      })
    },

    getFreeTrialAccess () {
      rfpFreeTrial().then(res => {
        if (res.data.results) {
          this.isFreeTrial = res.data.results[0].is_freeTrial
        }
      }).catch(err => {
        console.log('Failed to get rfps free trial: ', err)
      })
    }
  }
}
</script>
